import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import styled from "styled-components";

const MyComponent = () => {
    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Title</title>
                <meta name="description" content="Description"/>
            </Helmet>

            <StyledComponent>
                components
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`
    
`;

export default MyComponent;
